var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChildcareSickLeave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.75C1 4.64543 1.89543 3.75 3 3.75H13C14.1046 3.75 15 4.64543 15 5.75V12.25C15 13.3546 14.1046 14.25 13 14.25H3C1.89543 14.25 1 13.3546 1 12.25V5.75Z",
    fill: "#C1694F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.75V7.25L4.5 3.75H3C1.89543 3.75 1 4.64543 1 5.75Z",
    fill: "#A4523A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.75V7.25L11.5 3.75H13C14.1046 3.75 15 4.64543 15 5.75Z",
    fill: "#A4523A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.25V10.75L4.5 14.25H3C1.89543 14.25 1 13.3546 1 12.25Z",
    fill: "#A4523A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.25V10.75L11.5 14.25H13C14.1046 14.25 15 13.3546 15 12.25Z",
    fill: "#A4523A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9C11.5 10.933 9.933 12.5 8 12.5C6.067 12.5 4.5 10.933 4.5 9C4.5 7.067 6.067 5.5 8 5.5C9.933 5.5 11.5 7.067 11.5 9Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87545 9.74955H8.74968V10.8757C8.74968 11.2893 8.41412 11.625 7.99974 11.625C7.58588 11.625 7.25045 11.2893 7.25045 10.8757V9.74955H6.12455C5.71069 9.74955 5.375 9.41386 5.375 9C5.375 8.58578 5.71069 8.25071 6.12455 8.25071H7.25045V7.12455C7.25045 6.71033 7.58601 6.375 7.99974 6.375C8.41408 6.375 8.74968 6.71033 8.74968 7.12455V8.25071H9.87545C10.2897 8.25071 10.625 8.58591 10.625 9C10.625 9.41386 10.2897 9.74955 9.87545 9.74955Z",
    fill: "#DD2E44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59299 2H6.40729C5.35545 2 4.5 2.78507 4.5 3.75H5.62177C5.62177 3.35278 5.97414 3.02931 6.40732 3.02931H9.59302C10.0261 3.02931 10.3782 3.35278 10.3782 3.75H11.5C11.5 2.78484 10.6447 2 9.59299 2Z",
    fill: "#1E2A3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildcareSickLeave);
export default __webpack_public_path__ + "static/media/childcare-sick-leave.8aeeda4cabe9797836e4886897afeda6.svg";
export { ForwardRef as ReactComponent };